import {Manifest} from "../../../../../../../generated/graphql";
import {
  getAllActiveStops,
  getFinalCompletedStop,
  getNextActiveStop,
  getNextActiveStops,
  getOnSiteStop,
  getTopStopByConfig
} from "../../../../../../../utils/stops/StopUtils";
import {getArrayFromField} from "../../../../../../../utils/General";
import {TopStopInformationValue} from "../../../../../card-configuration/v2/constants/enums";

export const getStopList = (
  manifest: Manifest,
  isSelected: boolean,
  topStopInfo: TopStopInformationValue,
  numberOfStops: number
) => {
  const finalCompletedStop = getFinalCompletedStop(manifest);

  //if final completed stop exists, return it
  if (finalCompletedStop) {
    return getArrayFromField(finalCompletedStop);
  }

  const allActiveStops = getAllActiveStops(manifest);

  const topStop = getTopStopByConfig(manifest, topStopInfo);

  if (topStop) {
    const newStopList = allActiveStops?.filter((s) => ![topStop.jobStopId].includes(s.jobStopId));
    newStopList?.unshift(topStop);
    return isSelected ? newStopList : newStopList?.slice(0, numberOfStops);
  }

  //if no onsite or lowest rank completed stop, return next active stops
  return isSelected ? allActiveStops : getNextActiveStops(manifest, numberOfStops);
};

export const getStopListForMinimalCard = (manifest: Manifest) => {
  const stop = getOnSiteStop(manifest) || getFinalCompletedStop(manifest) || getNextActiveStop(manifest);
  return getArrayFromField(stop);
};
